<template>
  <v-data-table
    ref="ordersTable"
    :loading="loading"
    :headers="headers"
    :items="days"
    sort-by="date"
    class="lightYellow elevation-1 d-print-block font-readex"
    :sort-desc="true"
    :search="search"
    locale="cs"
  >
    <template v-slot:top>
      <v-toolbar color="lightYellow" flat elevation="0">
        <v-toolbar-title>Objednávky strávníka</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-menu
          v-model="monthPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="form.month"
              label="Filtr měsíce"
              hide-details
              single-line
              prepend-icon="mdi-calendar"
              readonly
              outlined
              v-bind="attrs"
              v-on="on"
              dense
            ></v-text-field>
          </template>
          <v-date-picker
            type="month"
            v-model="form.month"
            @input="monthPicker = false"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <v-select
          :items="boarders"
          label="Vyberte strávníka"
          item-text="name"
          item-value="id"
          single-line
          outlined
          hide-details
          dense
          deletable-chips
          small-chips
          class="ml-2"
          v-model="form.boarderId"
        ></v-select>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Vyhledávání"
          class="ml-2"
          outlined
          single-line
          dense
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    boarders: {
      required: true,
      type: Array
    }
  },
  name: 'BoarderOrdersByDate',
  data () {
    return {
      search: '',
      monthPicker: false,
      loading: false,
      form: {
        boarderId: null,
        month: new Date().toISOString().substr(0, 7)
      },
      days: [],
      headers: [
        {
          text: 'Datum',
          align: 'start',
          sortable: false,
          value: 'date'
        },
        { text: 'Položka', value: 'itemName' },
        { text: 'Denní doba', value: 'itemTimeType' },
        { text: 'Cena', value: 'itemPrice' }
      ]
    }
  },
  methods: {
    getDays () {
      this.loading = true
      this.$http.post('/boarders/month-orders', this.keysToSnakeCase(this.form))
        .then(res => {
          this.loading = false
          this.days = this.keysToCamelCase(res.data)
        })
    }
  },
  created () {
  },
  watch: {
    form: {
      handler (val) {
        if (val.month && val.boarderId) {
          this.getDays()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
